import type { TargetAttributeDto } from '@/generated/model/targetAttributeDto';
import type { TargetAttributeDtoType } from '@/generated/model/targetAttributeDtoType';

export function mergeSavedTargetAttributeRows(
  originalRows: TargetAttributeDto[],
  savedRows: TargetAttributeDto[]
): TargetAttributeDto[] {
  const savedRowsByKey = new Map(savedRows.map((row) => [row.key, row]));
  return originalRows.map((row) => savedRowsByKey.get(row.key) ?? row);
}

export function normalizeAttributeValueForComparison(value: unknown, type: TargetAttributeDtoType) {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (Number.isNaN(value)) {
    return value;
  }
  if (type === '@date' || type === '@int' || type === '@long' || type === '@double') {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) && (type !== '@date' || numberValue !== 0) ? numberValue : undefined;
  }
  if ((type === '@class' || type === '@list') && typeof value === 'object' && 'id' in value) {
    return value.id;
  }
  return value;
}

export function getTargetAttributeDateTimestamp(value: Date | null) {
  return value === null ? undefined : value.getTime();
}
